import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import materialInventoryListAction from './materialInventoryList.action.json' with { type: 'json' }
import { materialInventoryObject } from '../materialInventoryObject'

export const materialInventoryExpression = expression(materialInventoryObject.shape)

const materialInventoryListDefinition = defineAction({
  ...materialInventoryListAction,

  input: z.object({
    filter: materialInventoryExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      quantity: 'Quantidade',
      type: 'Tipo',
      materialId: 'Material',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(materialInventoryObject),
    count: z.number(),
  }),
})

export default materialInventoryListDefinition
